import { LatLng } from "../common/latlng";
import { LatLngBounds } from "../common/latlng-bounds";
/**
 * 栅格
 */
export class Raster {
    /**
     * 动态栅格（实时渲染）
     */
    get dynamic() {
        return false;
    }
    /**
     * 画布存放Image
     */
    get canvas() {
        return this._canvas;
    }
    /**
     * 栅格经纬度边界
     */
    get bounds() {
        return this._latlngBounds;
    }
    /**
     * 包络矩形
     */
    get latlngBounds() {
        return this._latlngBounds;
    }
    get planeBounds() {
        return this._planeBounds;
    }
    get screenBounds() {
        return this._screenBounds;
    }
    /**
      * 设置坐标系并投影
      */
    set crs(value) {
        this._crs = value;
        this.project();
    }
    /**
     * 创建栅格
     * @remarks
     * 遍历图形集合进行绘制
     * @param {number} xmin - 经度左值
     * @param {number} ymin - 纬度下值
     * @param {number} xmax - 经度右值
     * @param {number} ymax - 纬度上值
     * @param {number} width - 栅格宽度
     * @param {number} height - 栅格高度
     * @param {number} cellsize - 栅格大小
     */
    constructor(xmin, ymin, xmax, ymax, width = 1000, height = 1000) {
        this._canvas = document.createElement("canvas");
        this._canvas.width = width;
        this._canvas.height = height;
        this._latlngBounds = new LatLngBounds(new LatLng(ymin, xmin), new LatLng(ymax, xmax));
    }
}
